'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.CLEAR_LOCATION_NEAR_ME = exports.LOCATION_NEAR_ME = exports.CLEAR_LOCATION = exports.LOCATION = exports.CLEAR_DIRECTORY = exports.DIRECTORY = exports.CLEAR_SCANS = exports.SCANS = exports.CLEAR_HEALTH_CHECKS = exports.HEALTH_CHECKS = undefined;

var _doctifyUtils = require('doctify-utils');

var HEALTH_CHECKS = exports.HEALTH_CHECKS = 'AUTOCOMPLETE:HEALTH_CHECKS';
var CLEAR_HEALTH_CHECKS = exports.CLEAR_HEALTH_CHECKS = 'AUTOCOMPLETE:CLEAR_HEALTH_CHECKS';
var SCANS = exports.SCANS = 'AUTOCOMPLETE:SCANS';
var CLEAR_SCANS = exports.CLEAR_SCANS = 'AUTOCOMPLETE:CLEAR_SCANS';
var DIRECTORY = exports.DIRECTORY = 'AUTOCOMPLETE:DIRECTORY';
var CLEAR_DIRECTORY = exports.CLEAR_DIRECTORY = 'AUTOCOMPLETE:CLEAR_DIRECTORY';
var LOCATION = exports.LOCATION = 'AUTOCOMPLETE:LOCATION';
var CLEAR_LOCATION = exports.CLEAR_LOCATION = 'AUTOCOMPLETE:CLEAR_LOCATION';
var LOCATION_NEAR_ME = exports.LOCATION_NEAR_ME = 'AUTOCOMPLETE:LOCATION_NEAR_ME';
var CLEAR_LOCATION_NEAR_ME = exports.CLEAR_LOCATION_NEAR_ME = 'AUTOCOMPLETE:CLEAR_LOCATION_NEAR_ME';

var AutocompleteActions = {
	getHealthChecksAutocomplete: function getHealthChecksAutocomplete(filter) {
		return (0, _doctifyUtils.createAction)({
			url: 'directory/autocomplete',
			method: 'GET',
			parameters: { filter: filter, records: 5, types: 'health_checks' },
			actionType: HEALTH_CHECKS,
			keyword: 'matching_items'
		});
	},
	clearHealthChecksAutocomplete: function clearHealthChecksAutocomplete() {
		return {
			type: CLEAR_HEALTH_CHECKS
		};
	},
	getScansAutocomplete: function getScansAutocomplete(filter) {
		return (0, _doctifyUtils.createAction)({
			url: 'directory/autocomplete',
			method: 'GET',
			parameters: { filter: filter, records: 5, types: 'scans' },
			actionType: SCANS,
			keyword: 'matching_items'
		});
	},
	clearScansAutocomplete: function clearScansAutocomplete() {
		return {
			type: CLEAR_SCANS
		};
	},
	getDirectoryAutocomplete: function getDirectoryAutocomplete(filter) {
		return (0, _doctifyUtils.createAction)({
			url: 'directory/autocomplete',
			method: 'GET',
			parameters: { filter: filter, records: 50, types: 'specialties,specialists' },
			actionType: DIRECTORY,
			keyword: 'matching_items'
		});
	},
	clearDirectoryAutocomplete: function clearDirectoryAutocomplete() {
		return {
			type: CLEAR_DIRECTORY
		};
	},

	/**
  * Retrieves place autocomplete predictions based on the supplied autocomplete request
  * For more information see https://developers.google.com/maps/documentation/javascript/reference#AutocompleteService
  * @param {object} request An object containing the following properties
  * 						   {
  * 								input: <string> the user entered input string,
  * 								offset: <number> the character position in the input term at which the service uses test for predictions,
  *								types: Array<string> the type of regions to return
  *							}
  * @returns {Promise} a Promise that resolves with an array of autocompletion predictions or fails with the service Status
  **/
	getLocationAutocomplete: function getLocationAutocomplete(input) {
		var actionType = LOCATION;
		var REQUEST = actionType + '_REQUESTED';
		var SUCCESS = actionType + '_RECEIVED';
		var FAILURE = actionType + '_FAILED';
		var request = {
			input: input,
			componentRestrictions: { country: 'gb' }
		};
		function toAutocomplete(googlePlace) {
			return {
				id: googlePlace.id,
				name: googlePlace.description,
				icon_uri: '',
				sort_order: 0,
				type: 'location'
			};
		}

		return function (dispatch) {
			dispatch({ type: REQUEST });
			if (typeof window !== 'undefined' && window.google) {
				var autocompleteService = new window.google.maps.places.AutocompleteService();
				return new Promise(function (resolve) {
					autocompleteService.getPlacePredictions(request, function (predictions, status) {
						if (predictions && predictions.length) {
							dispatch({ type: SUCCESS, response: predictions.map(toAutocomplete) });
						} else {
							dispatch({ type: FAILURE, status: status });
						}
						resolve();
					});
				});
			} else {
				dispatch({ type: FAILURE });
				return Promise.resolve();
			}
		};
	},
	clearLocationAutocomplete: function clearLocationAutocomplete() {
		return {
			type: CLEAR_LOCATION
		};
	},
	getLocationNearMe: function getLocationNearMe() {
		var actionType = LOCATION_NEAR_ME;
		var REQUEST = actionType + '_REQUESTED';
		var SUCCESS = actionType + '_RECEIVED';
		var FAILURE = actionType + '_FAILED';

		return function (dispatch) {
			dispatch({ type: REQUEST });

			return new Promise(function (resolve, reject) {
				var nearMeSuccess = function nearMeSuccess(position) {
					dispatch({ type: SUCCESS, position: position });
					resolve();
				};

				var nearMeFailure = function nearMeFailure() {
					dispatch({ type: FAILURE });
					reject();
				};

				if (navigator) {
					navigator.geolocation.getCurrentPosition(nearMeSuccess, nearMeFailure, { timeout: 5000 });
				} else {
					dispatch({ type: FAILURE });
					reject();
				}
			});
		};
	},
	clearLocationNearMe: function clearLocationNearMe() {
		return {
			type: CLEAR_LOCATION_NEAR_ME
		};
	}
};

exports.default = AutocompleteActions;


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-global-redux/lib/actions/autocomplete.js
// module id = 647
// module chunks = 0